import { useEffect, useMemo, useState } from 'react';

import { HomeFeedItemURLToken, parseHomeFeedItemText } from '@jebel/utils';

import { LinkPreview } from 'shared/components/ui';
import { MentionsText } from 'shared/features/mentions';
import { useHomeFeedCardData, useHomeFeedCardHaveBeenShown } from 'shared/features/posts/providers';
import { formatLegacyDate } from 'shared/utils/date';

import { Container, Content, LegacyDate } from './HomeFeedCardContent.styles';
import { HomeFeedCardGallery } from './HomeFeedCardGallery';

export function HomeFeedCardContent() {
  const [links, setLinks] = useState<string[]>([]);

  const post = useHomeFeedCardData();
  const haveBeenShown = useHomeFeedCardHaveBeenShown();

  const legacyDate = useMemo(() => {
    return formatLegacyDate(post.legacyDate);
  }, [post.legacyDate]);

  useEffect(() => {
    const tokens = parseHomeFeedItemText(post.text as string);

    const urls = tokens.filter(
      (section): section is HomeFeedItemURLToken => section.token === 'url',
    );

    setLinks(urls.map(token => token.url));
  }, [post.text]);

  return (
    <Container>
      <Content>
        {post.legacyDate && <LegacyDate label={legacyDate} />}

        <MentionsText text={post.text ?? ''} paragraph={false} />
      </Content>

      <HomeFeedCardGallery />

      {links.length > 0 && haveBeenShown && (
        <Content>
          {links.map(link => (
            <LinkPreview key={link} url={link} />
          ))}
        </Content>
      )}
    </Container>
  );
}
